import { render, staticRenderFns } from "./LlTextButtonList.vue?vue&type=template&id=05996753"
import script from "./LlTextButtonList.vue?vue&type=script&lang=js"
export * from "./LlTextButtonList.vue?vue&type=script&lang=js"
import style0 from "./LlTextButtonList.vue?vue&type=style&index=0&id=05996753&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports